import React from 'react'
import mixpanel from 'mixpanel-browser'
import Header from './components/Header'
import RetroGrid from './components/RetroGrid'
import About from './components/About'
import Experience from './components/Experience'
import Skills from './components/Skills'
import Partnerships from './components/Partnerships'
import Education from './components/Education'

// Primary-button chamfer: one 9px bottom-right cut
const BUTTON_CHAMFER = 'polygon(0 0,100% 0,100% calc(100% - 9px),calc(100% - 9px) 100%,0 100%)'

function Resume() {

    mixpanel.init('967772639ff06d979a760099b3066fe5', {debug: false, track_pageview: false, persistence: 'localStorage'})
    mixpanel.track('page-view')

    const handlePrint = () => {
        window.print()
    }

    const sections = [
        <About key="about" />,
        <Skills key="skills" />,
        <Partnerships key="partnerships" />,
        <Experience key="experience" />,
        <Education key="education" />,
    ]

    return (
        <div className="min-h-screen bg-paper font-body text-body">
            {/* Print Button */}
            <button
                onClick={handlePrint}
                className="no-print fixed bottom-6 left-1/2 -translate-x-1/2 z-50 hidden md:flex items-center justify-center gap-2 px-12 py-3 font-display font-bold text-[13px] uppercase tracking-[.14em] text-white transition-transform duration-150 hover:brightness-110 active:translate-y-px shadow-xl"
                style={{
                    clipPath: BUTTON_CHAMFER,
                    background: 'linear-gradient(135deg,#0066FF,#4f46e5,#7c3aed)',
                }}
            >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
                </svg>
                Print // Resume
            </button>

            {/* Hero — full-bleed retro grid behind the header */}
            <div className="relative">
                <RetroGrid />
                <div className="relative max-w-4xl mx-auto px-6 md:px-12">
                    <Header />
                </div>
            </div>

            {/* Main Content */}
            <div className="max-w-4xl mx-auto px-6 pb-24 md:px-12">
                <div className="mt-10 space-y-12">
                    {sections.map((section, i) => (
                        <div
                            key={section.key}
                            className="motion-safe:animate-nb-enter"
                            style={{animationDelay: `${i * 40}ms`}}
                        >
                            {section}
                        </div>
                    ))}
                </div>

                {/* Mobile print button — inline at the end, where "save this" intent peaks */}
                <button
                    onClick={handlePrint}
                    className="no-print md:hidden mt-12 flex w-full items-center justify-center gap-2 px-5 py-3 font-display font-bold text-[13px] uppercase tracking-[.14em] text-white active:translate-y-px"
                    style={{
                        clipPath: BUTTON_CHAMFER,
                        background: 'linear-gradient(135deg,#0066FF,#4f46e5,#7c3aed)',
                    }}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
                    </svg>
                    Print // Resume
                </button>

                {/* Status strip */}
                <footer className="no-print mt-16 flex flex-col sm:flex-row items-center justify-between gap-1 border-t border-line pt-3 font-mono text-[10px] tracking-[.15em] uppercase text-faint">
                    <span>YC.OS 12.0 {'//'} Grid: Stable {'//'} San Juan, PR</span>
                    <span>Shipping beats strategy {'»'}</span>
                </footer>
            </div>
        </div>
    )
}

export default Resume
